import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Reminder } from '../../api/chat';

interface State {
  items: Reminder[];
  hydrated: boolean;
}

const initialState: State = { items: [], hydrated: false };

const slice = createSlice({
  name: 'reminders',
  initialState,
  reducers: {
    bulkHydrate(state, action: PayloadAction<Reminder[]>) {
      state.items = action.payload;
      state.hydrated = true;
    },
    upsertReminder(state, action: PayloadAction<Reminder>) {
      const idx = state.items.findIndex(r => r.id === action.payload.id);
      if (idx >= 0) state.items[idx] = action.payload;
      else state.items.unshift(action.payload);
    },
    removeReminder(state, action: PayloadAction<string>) {
      state.items = state.items.filter(r => r.id !== action.payload);
    },
    clearReminders(state) {
      state.items = [];
      state.hydrated = false;
    },
  },
});

export const { bulkHydrate, upsertReminder, removeReminder, clearReminders } = slice.actions;

export const selectReminders = (s: any) => s.reminders.items as Reminder[];
export const selectRemindersHydrated = (s: any) => s.reminders.hydrated as boolean;

export default slice.reducer;
